import React from 'react';
import PropTypes from 'prop-types';

import { useTooltip } from '../../hooks';
import ToggleSwitchButton from './ToggleSwitchButton';

import styles from '../../styles/views/components/ToggleEditAccess.module.scss';

const ToggleEditAccess = ({
  isUserEnableToEdit,
  onToggleEditAccess,
  description,
  tooltipText,
  isDisabled,
}) => {
  useTooltip();

  return (
    <div className={[styles.toggleWrapper, isDisabled ? styles.disabled : ''].join(' ')}>
      <span>{description}</span>
      <ToggleSwitchButton
        customeWrapperStyles={styles.toggleSwitch}
        isChecked={isUserEnableToEdit}
        handleChange={onToggleEditAccess}
        tooltip={tooltipText}
        isDisabled={isDisabled}
      />
    </div>
  );
};

ToggleEditAccess.propTypes = {
  isUserEnableToEdit: PropTypes.bool.isRequired,
  onToggleEditAccess: PropTypes.func.isRequired,
  description: PropTypes.string,
  tooltipText: PropTypes.string,
  isDisabled: PropTypes.bool,
};

ToggleEditAccess.defaultProps = {
  description: '',
  tooltipText: '',
  isDisabled: false,
};

export default ToggleEditAccess;
